<template>
  <div id="AttachedFileView">
    <v-card outlined>
      <v-card-title>{{ $t("vendor.headerStep5") }} </v-card-title>
      <v-card-text v-show="loading">
        <v-skeleton-loader type="article"></v-skeleton-loader>
      </v-card-text>
      <v-card-text v-show="!loading">
        <v-row v-if="propVendorType === 'oversea'">
          <v-col cols="12"><v-divider></v-divider></v-col>
          <v-col cols="12">
            <h3>{{ $t("vendor.registeredCapital") }}</h3>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.registeredCapitalTxt") }}</h4>
          </v-col>
          <v-col cols="6">
            <p v-if="descriptionModel.RegisteredCapital">
              {{ fucFormatter(descriptionModel.RegisteredCapital) }}
            </p>
          </v-col>
          <v-col cols="6">
            <h4>KYC Form</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileFromKYCRes.filePath === ''"
              :href="`${apiURl}${fileFromKYCRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{ fileFromKYCRes.filePath === "" ? "No File" : "View" }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="isOrdinary && propVendorType !== 'oversea'">
          <v-col cols="6">
            <h4>{{ $t("vendor.idCard") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-row>
              <v-col cols="4">
                <h4>{{ $t("vendor.ExpireDate") }}</h4>
              </v-col>
              <v-col cols="6">
                <p v-if="fileIdCard.ExpireDate">
                  {{ fileIdCard.ExpireDate.substring(0, 10) }}
                </p>
                <p v-else>—</p>
              </v-col>
              <v-col cols="4">
                <h4>{{ $t("vendor.document") }}</h4></v-col
              >
              <v-col cols="6" class="mb-2">
                <v-btn
                  small
                  outlined
                  tile
                  color="secondary"
                  :disabled="fileIdCardRes.filePath === ''"
                  :href="`${apiURl}${fileIdCardRes.filePath}`"
                  target="_blank"
                >
                  <v-icon left> mdi-eye </v-icon>
                  {{ fileIdCardRes.filePath === "" ? "No File" : "View" }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.ExpireDate") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileIdCardRes.filePath === ''"
              :href="`${apiURl}${fileIdCardRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{ fileIdCardRes.filePath === "" ? "No File" : "View" }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.fileCopyBankPassbook") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileCopyBankPassbookRes.filePath === ''"
              :href="`${apiURl}${fileCopyBankPassbookRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{ fileCopyBankPassbookRes.filePath === "" ? "No File" : "View" }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.fileHouseRegistration") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileHouseRegistrationRes.filePath === ''"
              :href="`${apiURl}${fileHouseRegistrationRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileHouseRegistrationRes.filePath === "" ? "No File" : "View"
              }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- Justic Person -->
        <v-row v-if="isJuristic && propVendorType !== 'oversea'">
          <v-col cols="6">
            <h4>{{ $t("vendor.fileCopyOfVATRegistrationCer") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileCopyOfVATRegistrationCerRes.filePath === ''"
              :href="`${apiURl}${fileCopyOfVATRegistrationCerRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileCopyOfVATRegistrationCerRes.filePath === ""
                  ? "No File"
                  : "View"
              }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.fileAffidavit") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-row>
              <v-col cols="4">
                <h4>{{ $t("vendor.ExpireDate") }}</h4>
              </v-col>
              <v-col cols="6">
                <p
                  v-if="fileAffidavit.ExpireDate"
                  :class="
                    checkDate(fileAffidavit.ExpireDate) ? 'red--text' : ''
                  "
                >
                  {{ fileAffidavit.ExpireDate.substring(0, 10) }}
                </p>
                <p v-else>—</p>
              </v-col>
              <v-col cols="4">
                <h4>{{ $t("vendor.document") }}</h4></v-col
              >
              <v-col cols="6" class="mb-2">
                <v-btn
                  small
                  outlined
                  tile
                  color="secondary"
                  :disabled="fileAffidavitRes.filePath === ''"
                  :href="`${apiURl}${fileAffidavitRes.filePath}`"
                  target="_blank"
                >
                  <v-icon left> mdi-eye </v-icon>
                  {{ fileAffidavitRes.filePath === "" ? "No File" : "View" }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
          <v-col cols="12">
            <h3>{{ $t("vendor.registeredCapital") }}</h3>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.registeredCapitalTxt") }}</h4>
          </v-col>
          <v-col cols="6">
            <p v-if="descriptionModel.RegisteredCapital">
              {{ fucFormatter(descriptionModel.RegisteredCapital) }}
            </p>
            <p v-else>—</p>
          </v-col>
          <v-col cols="6">
            <h4>
              {{ $t("vendor.fileListOfShareholders") }}
            </h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileListOfShareholdersRes.filePath === ''"
              :href="`${apiURl}${fileListOfShareholdersRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileListOfShareholdersRes.filePath === "" ? "No File" : "View"
              }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.fileBankStatement") }}</h4></v-col
          >
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileBankStatementRes.filePath === ''"
              :href="`${apiURl}${fileBankStatementRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{ fileBankStatementRes.filePath === "" ? "No File" : "View" }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- Government -->
        <div class="content" v-if="isGov && propVendorType !== 'oversea'">
          <h4>
            {{ $t("vendor.fileGovernmentAgencyEstablishment") }}
          </h4>
          <v-btn
            small
            outlined
            color="secondary"
            :disabled="fileGovernmentAgencyEstablishmentRes.filePath === ''"
            :href="`${apiURl}${fileGovernmentAgencyEstablishmentRes.filePath}`"
            target="_blank"
          >
            <v-icon left> mdi-eye </v-icon>
            {{
              fileGovernmentAgencyEstablishmentRes.filePath === ""
                ? "No File"
                : "View"
            }}
          </v-btn>
        </div>
        <!-- Other -->
        <v-row>
          <v-col cols="6">
            <h4>{{ $t("vendor.fileOthers") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileOthersRes.filePath === ''"
              :href="`${apiURl}${fileOthersRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{ fileOthersRes.filePath === "" ? "No File" : "View" }}
            </v-btn>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
        </v-row>
        <!-- Not required -->
        <v-row>
          <v-col cols="12">
            <h3>{{ $t("vendor.fileTurnoverDating") }}</h3>
          </v-col>
          <v-col cols="2">
            <h4>{{ $t("vendor.year1") }}</h4></v-col
          >
          <v-col cols="2">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileTurnoverDatingYear1Res.filePath === ''"
              :href="`${apiURl}${fileTurnoverDatingYear1Res.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileTurnoverDatingYear1Res.filePath === "" ? "No File" : "View"
              }}
            </v-btn>
          </v-col>
          <v-col cols="2">
            <h4>
              {{ $t("vendor.companyTurnOver") }}
              {{ decimals(fileTurnoverDatingYear1Res.companyturnover) }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.currency") }}
              {{ fileTurnoverDatingYear1Res.currency }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.fxrate") }} {{ fileTurnoverDatingYear1Res.fxrate }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.thbath") }} {{ decimals(fileTurnoverDatingYear1Res.thbath) }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>{{ $t("vendor.year2") }}</h4>
          </v-col>
          <v-col cols="2">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileTurnoverDatingYear2Res.filePath === ''"
              :href="`${apiURl}${fileTurnoverDatingYear2Res.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileTurnoverDatingYear2Res.filePath === "" ? "No File" : "View"
              }}
            </v-btn>
          </v-col>
          <v-col cols="2">
            <h4>
              {{ $t("vendor.companyTurnOver") }}
              {{ decimals(fileTurnoverDatingYear2Res.companyturnover) }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.currency") }}
              {{ fileTurnoverDatingYear2Res.currency }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.fxrate") }} {{ fileTurnoverDatingYear2Res.fxrate }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.thbath") }} {{ decimals(fileTurnoverDatingYear2Res.thbath) }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>{{ $t("vendor.year3") }}</h4>
          </v-col>
          <v-col cols="2">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileTurnoverDatingYear3Res.filePath === ''"
              :href="`${apiURl}${fileTurnoverDatingYear3Res.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileTurnoverDatingYear3Res.filePath === "" ? "No File" : "View"
              }}
            </v-btn>
          </v-col>
          <v-col cols="2">
            <h4>
              {{ $t("vendor.companyTurnOver") }}
              {{ decimals(fileTurnoverDatingYear3Res.companyturnover) }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.currency") }}
              {{ fileTurnoverDatingYear3Res.currency }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.fxrate") }} {{ fileTurnoverDatingYear3Res.fxrate }}
            </h4></v-col
          >
          <v-col cols="2">
            <h4>
              {{ $t("vendor.thbath") }} {{ decimals(fileTurnoverDatingYear3Res.thbath) }}
            </h4></v-col
          >
          <v-col cols="6">
            <!-- <h4>{{ $t("vendor.year3") }}</h4> -->
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
          <v-col cols="12">
            <h3>{{ $t("vendor.experienceYear") }}</h3>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.experienceIn") }}</h4>
          </v-col>
          <v-col cols="6">
            <p>{{ descriptionModel.ExperienceIn }}</p>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.experience") }}</h4>
          </v-col>
          <v-col cols="6">
            <p>
              {{
                descriptionModel.ExperienceYear +
                "." +
                descriptionModel.ExperienceMonth
              }}
            </p>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.document") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileWhichIndustriesExpRes.filePath === ''"
              :href="`${apiURl}${fileWhichIndustriesExpRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileWhichIndustriesExpRes.filePath === "" ? "No File" : "View"
              }}
            </v-btn>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
          <v-col cols="12">
            <h3>{{ $t("vendor.ISOName") }}</h3>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.certificates") }}</h4>
          </v-col>
          <v-col cols="6">
            <p>{{ descriptionModel.ISOName }}</p>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.document") }}</h4>
          </v-col>
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileWhatKindCertYouHaveRes.filePath === ''"
              :href="`${apiURl}${fileWhatKindCertYouHaveRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileWhatKindCertYouHaveRes.filePath === "" ? "No File" : "View"
              }}
            </v-btn>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
          <v-col cols="12">
            <h3>{{ $t("vendor.licenseName") }}</h3>
          </v-col>
          <v-col cols="6">
            <h4>{{ $t("vendor.licenses") }}</h4></v-col
          >
          <v-col cols="6">
            <p>{{ descriptionModel.LicenseName }}</p></v-col
          >
          <v-col cols="6">
            <h4>{{ $t("vendor.document") }}</h4></v-col
          >
          <v-col cols="6">
            <v-btn
              small
              outlined
              color="secondary"
              :disabled="fileWhatKindLicenseYouHaveRes.filePath === ''"
              :href="`${apiURl}${fileWhatKindLicenseYouHaveRes.filePath}`"
              target="_blank"
            >
              <v-icon left> mdi-eye </v-icon>
              {{
                fileWhatKindLicenseYouHaveRes.filePath === ""
                  ? "No File"
                  : "View"
              }}
            </v-btn>
          </v-col>
        </v-row></v-card-text
      ></v-card
    >
  </div>
</template>

<script>
import { apiConfig } from "../../services/config";
import { vendorservice } from "../../services/vendorservice";

export default {
  name: "AttachedFileView",
  props: {
    propType: {
      type: String,
      required: true,
    },
    propVendorType: {
      type: String,
      default: () => "",
    },
    propAttachmentDescription: {
      type: [Array, Object],
      require: false,
      default: () => {},
    },
  },
  data: () => ({
    apiURl: apiConfig,
    attachments: {},
    descriptionModel: {
      RegisteredCapital: 0,
      ExperienceIn: "",
      ExperienceYear: 0,
      ExperienceMonth: 0,
      ISOName: "",
      LicenseName: "",
    },
    // file resource
    fileIdCard: {
      ExpireDate: "",
    },
    fileFromKYCRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileListOfShareholders: {
      AttachmentType: "ListOfShareholders",
      ExpireDate: "",
    },
    fileCopyOfVATRegistrationCerRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileAffidavitRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileAffidavit: {
      ExpireDate: "",
    },
    // file resource
    fileListOfShareholdersRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileBankStatementRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileOthersRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileRevenueDatingyYear1Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileRevenueDatingyYear2Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileRevenueDatingyYear3Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    fileTurnoverDatingYear1Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
      fxrate: "",
      thbath: 0,
      currency: "",
      companyturnover: 0,
    },
    // file resource
    fileTurnoverDatingYear2Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
      fxrate: "",
      thbath: 0,
      currency: "",
      companyturnover: 0,
    },
    // file resource
    fileTurnoverDatingYear3Res: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
      fxrate: "",
      thbath: 0,
      currency: "",
      companyturnover: 0,
    },
    // file resource
    fileWhichIndustriesExpRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileWhatKindCertYouHaveRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileWhatKindLicenseYouHaveRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileIdCardRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileCopyBankPassbookRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileCertificateRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileHouseRegistrationRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileGovernmentAgencyEstablishmentRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    // file resource
    fileRegisteredCapitalRes: {
      id: 0,
      fileName: "",
      filePath: "",
      hasFile: false,
    },
    loading: false,
  }),
  async mounted() {
    await this.getAttachment();

    this.checkNull(this.propAttachmentDescription);
    this.fucFormatter();
  },
  watch: {
    propAttachmentDescription(value) {
      if (value) this.checkNull(value);
    },
  },
  computed: {
    isOrdinary() {
      if (this.propType === "1") return true;
      return false;
    },
    isJuristic() {
      if (this.propType === "2") return true;
      return false;
    },
    isGov() {
      if (this.propType === "3") return true;
      return false;
    },
  },
  methods: {
    async getAttachment() {
      this.loading = true;
      let userName = "";
      if (this.$store.state.AppActiveUser.userName.length === 18) {
        userName = this.$store.state.AppActiveUser.userName;
      } else {
        userName = this.$store.state.AppActiveUser.userName + "00000";
      }
      this.attachments = await vendorservice.GetVendorAttachment(userName);

      await this.getIshasFile();
      this.loading = false;
    },
    checkNull(obj) {
      Object.keys(obj).forEach(function (key) {
        if (obj[key] === "") {
          obj[key] = "—";
        }
      });
      this.descriptionModel = obj;
    },
    async getIshasFile() {
      const FileType = [
        "IdCard",
        "CopyBankPassbook",
        "CopyOfVATRegistrationCer",
        "Certificate",
        "ListOfShareholders",
        "GovernmentAgencyEstablishment",
        "RevenueDatingyYear1",
        "RevenueDatingyYear2",
        "RevenueDatingyYear3",
        "TurnoverDatingYear1",
        "TurnoverDatingYear2",
        "TurnoverDatingYear3",
        "RegisteredCapital",
        "WhichIndustriesExp",
        "WhatKindCertYouHave",
        "WhatKindLicenseYouHave",
        "Others",
        "Affidavit",
        "HouseRegistration",
        "FinancialStatement",
        "FromKYC",
      ];
      for (let i = 0; i < FileType.length; i++) {
        const resData = this.attachments.find(
          ({ attachmentType }) => attachmentType === FileType[i]
        );
        await this.pushDataAttachment(FileType[i], resData);
      }
    },
    pushDataAttachment(attachmentType, data) {
      if (attachmentType === "FinancialStatement") {
        if (data !== undefined) {
          this.fileBankStatementRes.id = data.id;
          this.fileBankStatementRes.fileName = data.fileName;
          this.fileBankStatementRes.filePath = data.filePath;
          this.fileBankStatementRes.hasFile = true;
        } else this.fileBankStatementRes.hasFile = false;
      } else {
        if (data != undefined) {
          this[`file${attachmentType}Res`].id = data.id;
          this[`file${attachmentType}Res`].fileName = data.fileName;
          this[`file${attachmentType}Res`].filePath = data.filePath;
          this[`file${attachmentType}Res`].hasFile = true;
          this[`file${attachmentType}Res`].currency = data.currency;
          this[`file${attachmentType}Res`].fxrate = data.fxrate;
          this[`file${attachmentType}Res`].thbath = data.thbath;
          this[`file${attachmentType}Res`].companyturnover =
            data.companyTurnOver;
          if (attachmentType === "IdCard") {
            this.fileIdCard.ExpireDate = data.expireDate;
          }
          if (attachmentType === "ListOfShareholders") {
            this.fileListOfShareholders.ExpireDate = data.expireDate;
          }
          if (attachmentType === "Affidavit") {
            this.fileAffidavit.ExpireDate = data.expireDate;
          }
        } else {
          this[`file${attachmentType}Res`].hasFile = false;
        }
      }
    },
    fucFormatter(numer) {
      const formatter = new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: "THB",
        minimumFractionDigits: 0,
      });
      const result = formatter.format(+numer).substring(1);
      return result;
    },
    checkDate(date) {
      var start = this.moment(date).format("YYYY-MM-DD");
      var end = this.moment().format("YYYY-MM-DD");
      const monthDifference = this.moment(new Date(end)).diff(
        new Date(start),
        "months",
        true
      );
      return monthDifference >= 6 ? true : false;
    },
    decimals(number)
    {
      if (number != null)
      {
        try{
          const num = parseFloat(number);
          return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        catch(e){
          return "0.00";
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.col {
  padding: 0.3rem;
}
h4 {
  color: #103a5d;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
}
h3 {
  font-size: 14px;
  margin-bottom: 0.5rem;
}
p {
  color: #555555;
  margin: 0;
}
</style>
